<template>
    <p>US ${{amountPaid/100}}.0</p>
</template>

<script>
export default {
    name: 'Amount',
    props: {
        amountPaid: Number
    }
}
</script>